import React from "react";

import Activity from "@/assets/icons/activity.svg?react";
import AddOutlined from "@/assets/icons/add-outlined.svg?react";
import AddReaction from "@/assets/icons/add-reaction.svg?react";
import AiStars from "@/assets/icons/ai-stars.svg?react";
import AlertTriangle from "@/assets/icons/alert-triangle.svg?react";
import ArrowLeft from "@/assets/icons/arrow-left.svg?react";
import ArrowRight from "@/assets/icons/arrow-right.svg?react";
import Bell from "@/assets/icons/bell.svg?react";
import Calendar from "@/assets/icons/calendar.svg?react";
import CE from "@/assets/icons/CE.svg?react";
import Check from "@/assets/icons/check.svg?react";
import ChevronDown from "@/assets/icons/chevron-down.svg?react";
import ChevronRight from "@/assets/icons/chevron-right.svg?react";
import ChevronUpDown from "@/assets/icons/chevron-up-down.svg?react";
import ChevronUp from "@/assets/icons/chevron-up.svg?react";
import Clock from "@/assets/icons/clock.svg?react";
import Cog from "@/assets/icons/cog.svg?react";
import ColorSelect from "@/assets/icons/color-select.svg?react";
import Copy from "@/assets/icons/copy.svg?react";
import Disk from "@/assets/icons/disk.svg?react";
import DoubleArrowRightIcon from "@/assets/icons/double-arrow-right.svg?react";
import DoubleCheckMarkIcon from "@/assets/icons/double-check-mark.svg?react";
import Download from "@/assets/icons/download.svg?react";
import Edit from "@/assets/icons/edit.svg?react";
import Email from "@/assets/icons/email.svg?react";
import Exit from "@/assets/icons/exit.svg?react";
import EyeCrossed from "@/assets/icons/eye-crossed.svg?react";
import Eye from "@/assets/icons/eye.svg?react";
import FilePlus from "@/assets/icons/file-plus.svg?react";
import FileUpload from "@/assets/icons/file-upload.svg?react";
import File from "@/assets/icons/file.svg?react";
import Forward from "@/assets/icons/forward.svg?react";
import Globe from "@/assets/icons/globe.svg?react";
import Hamburger from "@/assets/icons/hamburger.svg?react";
import Phone from "@/assets/icons/ic-phone.svg?react";
import Info from "@/assets/icons/info.svg?react";
import Injection from "@/assets/icons/injection.svg?react";
import InsulinPen from "@/assets/icons/insulin_pen.svg?react";
import Letter from "@/assets/icons/letter.svg?react";
import LogoBlueFull from "@/assets/icons/logo-steto-blue-full.svg?react";
import LogoRoundFull from "@/assets/icons/logo-steto-round-full.svg?react";
import Manual from "@/assets/icons/manual.svg?react";
import Meal from "@/assets/icons/meal.svg?react";
import PhoneOutline from "@/assets/icons/phone.svg?react";
import Plug from "@/assets/icons/plug.svg?react";
import Plus from "@/assets/icons/plus.svg?react";
import Pump from "@/assets/icons/pump.svg?react";
import QuestionCircle from "@/assets/icons/question-circle.svg?react";
import Reader from "@/assets/icons/reader.svg?react";
import ReceiptIcon from "@/assets/icons/receipt.svg?react";
import RobotIcon from "@/assets/icons/robot.svg?react";
import Search from "@/assets/icons/search.svg?react";
import SendMessage from "@/assets/icons/send-message.svg?react";
import Sensor from "@/assets/icons/sensor.svg?react";
import SmallArrowDown from "@/assets/icons/small-arrow-down.svg?react";
import SmallArrowUp from "@/assets/icons/small-arrow-up.svg?react";
import Stethoscope from "@/assets/icons/stethoscope.svg?react";
import Sync from "@/assets/icons/sync.svg?react";
import TimeRewind from "@/assets/icons/time-rewind.svg?react";
import Trash from "@/assets/icons/trash.svg?react";
import UserPlus from "@/assets/icons/user-plus.svg?react";
import Users from "@/assets/icons/users.svg?react";

export type IconType = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

/**
 * All icons consumed by the app — every component reads `Icons.<name>`, never an
 * `*.svg?react` import directly. New icons come from FlatIcon, land in
 * `src/assets/icons/<kebab-case-name>.svg`, and get registered here. See RULES.md.
 */
export const Icons = {
  activity: Activity,
  addOutlined: AddOutlined,
  addReaction: AddReaction,
  aiStars: AiStars,
  alertTriangle: AlertTriangle,
  arrowDown: SmallArrowDown,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  arrowUp: SmallArrowUp,
  bell: Bell,
  calendar: Calendar,
  ce: CE,
  check: Check,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  chevronDown: ChevronDown,
  chevronUpDown: ChevronUpDown,
  clock: Clock,
  cog: Cog,
  colorSelect: ColorSelect,
  copy: Copy,
  disk: Disk,
  doubleArrowRight: DoubleArrowRightIcon,
  doubleCheck: DoubleCheckMarkIcon,
  download: Download,
  edit: Edit,
  email: Email,
  exit: Exit,
  eye: Eye,
  eyeCrossed: EyeCrossed,
  filePlus: FilePlus,
  fileUpload: FileUpload,
  file: File,
  forward: Forward,
  globe: Globe,
  hamburger: Hamburger,
  info: Info,
  injection: Injection,
  insulinPen: InsulinPen,
  letter: Letter,
  logoBlueFull: LogoBlueFull,
  logoRoundFull: LogoRoundFull,
  manual: Manual,
  meal: Meal,
  phone: Phone,
  phoneOutline: PhoneOutline,
  plug: Plug,
  plus: Plus,
  pump: Pump,
  questionCircle: QuestionCircle,
  reader: Reader,
  receipt: ReceiptIcon,
  robot: RobotIcon,
  search: Search,
  sendMessage: SendMessage,
  sensor: Sensor,
  stethoscope: Stethoscope,
  sync: Sync,
  timeRewind: TimeRewind,
  trash: Trash,
  userPlus: UserPlus,
  users: Users,
} satisfies { [key: string]: IconType };
